import { defineMessages } from 'react-intl';

export default defineMessages({
  seriesString: {
    id: 'cartSeries',
    description: 'in cart series',
    defaultMessage: 'SERIES',
  },
  totalSelectedString: {
    id: 'totalSelected',
    description: 'total selected',
    defaultMessage: 'Total Selected',
  },
});
